// extracted by mini-css-extract-plugin
module.exports = {"icon":"Select_icon__2tpm0","container":"Select_container__14ZIf","items":"Select_items__2meTu"};